import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import AppContext from '../context/AppContext';

/**
 * hook that builds on useLocation to parse
 * the query string for you.
 *
 * @name useAiCheck
 */
export default function () {
  const { appConfig = {} } = useContext(AppContext);
  if (appConfig.isVerify) {
    const location = useLocation();
    if (location.state && location.state.aiCheckId)
      return location.state.aiCheckId;
    return null;
  } else {
    return appConfig.servers.dicomWeb[0].checkId;
  }
}
